// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import './FilterTab.scss';

type Props = {
  onEdit: Function, // this function takes the tab index, the caller is supposed to open up a edit dialog
  onDelete: Function, // this function takes the tab index, the caller is supposed to remove this tab
  index: Number,
  lhs: string, // i.e. field name
  operator: string,
  rhs: any, // i.e. filter value
};

// FilterTab is used to display a selected filter
// it allows the user to edit or delete the filter
export default class FilterTab extends Component {
  props: Props;

  onEditClick = () => {
    this.props.onEdit(this.props.index);
  };

  onDeleteClick = () => {
    this.props.onDelete(this.props.index);
  };

  render() {
    const isNegatedFilter = _.startsWith(this.props.operator, '!');
    const tabClass = isNegatedFilter ? 'filter-tab-negated' : 'filter-tab';
    const textPrefix = isNegatedFilter ? 'NOT ' : '';

    return (
      <div className={tabClass}>
        <span onClick={this.onEditClick}>{`${textPrefix} ${_.get(this.props, 'lhs', '')}: ${_.get(this.props, 'rhs', '')}`}</span>
        &nbsp;&nbsp;&nbsp;
        <i className="delete icon tab-action" onClick={this.onDeleteClick} />
      </div>
    );
  }
}
